module.exports = __webpack_public_path__ + "img/mark_for_delete_asset.50eed712.png";